module.exports = __webpack_public_path__ + "static/img/icon1.d8190008.png";